export default __webpack_public_path__ + "static/media/D6D664D85FEAAD31.109ff130.png";